import us from './enUS.js'
const currentYear = new Date().getUTCFullYear()

export default {
  ...us,

  Header: {
    ...us.Header,
    titleFormat: (count: number, category: string) => `${count} Best ${category} ${currentYear} in the UK`,
    titleMagaTop: (count: number, category: string) => `Top-${count} ${category}`,
    titleMagaLoved: 'Loved in the UK',
  },
  ProductCard: {
    ...us.ProductCard,
    ctaText: (trafficType?: string, _partnerName?: string) => {
      switch (trafficType) {
        case 'organic-amazon-only':
          return 'More Info'
        case 'paid-long-tail':
          return 'More Info'
        case 'organic-buying-options':
          return 'View Product'
        case 'dws':
          return 'View Deal'
        default:
          return 'View Product'
      }
    },
  },
  Badge: {
    ...us.Badge,
    countryFavorite: "UK's Favorite",
    countryPick: "UK's Pick",
    countryTopRated: 'Top Rated in the UK',
  },
  ShippingSection: {
    title: "Shipping from Amazon's UK regional warehouses",
  },
} as typeof us
